import * as React from 'react'
import type {SVGProps} from 'react'
const SvgGlobalToolTip = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={20} height={20} viewBox="0 0 20 20" {...props}>
        <path
            fill="#55449a"
            fillRule="evenodd"
            d="M10 0c5.523 0 10 4.477 10 10s-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0m.271 13C9.566 13 9 13.594 9 14.258c0 .665.566 1.242 1.271 1.242.72 0 1.285-.577 1.285-1.242 0-.664-.564-1.258-1.285-1.258m.015-8C9.578 5 9 5.315 9 5.63v5.002l.008.072c.07.328.617.546 1.278.546.743 0 1.27-.25 1.27-.618V5.63l-.008-.067C11.48 5.272 10.976 5 10.286 5"
        />
    </svg>
)
export default SvgGlobalToolTip
